// extracted by mini-css-extract-plugin
module.exports = {"ssh":"VmLinks_ssh__2rDva","sshCommand":"VmLinks_sshCommand__-z2Gy"};